import API from "serviceshift-ui/api-client";
import { authenticityToken } from "@/lib/helpers";

export default {
  async createPaymentMethodTokenExport(_, { processor, url }) {
    const request = await API.makeRequest(url, {
      method: "POST",
      contentType: "application/json",
      headers: { "X-CSRF-Token": authenticityToken() },
      data: {
        processor
      }
    });

    return request.data;
  }
};
